export default __webpack_public_path__ + "0e7f335fc56256dd73111c441d741037.svg";